(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductTabs {
    constructor() {
      this.buttons = document.querySelectorAll('.tab-button');
      this.panels = document.querySelectorAll('.tab-panel');
      this.init();
    }

    init() {
      this.buttons.forEach((button) => {
        button.addEventListener('click', (e) => {
          const tabName = button.dataset.tab;
          this.switchTab(tabName);
        });
      });
    }

    switchTab(tabName) {
      // Update buttons
      this.buttons.forEach((btn) => {
        if (btn.dataset.tab === tabName) {
          btn.dataset.active = 'true';
        } else {
          btn.dataset.active = 'false';
        }
      });

      // Update panels
      this.panels.forEach((panel) => {
        if (panel.dataset.tabContent === tabName) {
          panel.dataset.active = 'true';
        } else {
          panel.dataset.active = 'false';
        }
      });
    }
  }

  class MobileStickyBar {
    constructor() {
      this.stickyBar = document.getElementById('mobile-add-to-cart');
      if (!this.stickyBar) return;

      this.originalPosition = null;
      this.isSticky = false;
      this.isHidden = false;
      this.init();
    }

    init() {
      // Scroll to top when page loads or is restored from cache
      this.scrollToTop();

      // Store original position
      this.updateOriginalPosition();

      // Check initial scroll position
      this.handleScroll();

      // Handle scroll with optimized performance
      let ticking = false;
      window.addEventListener(
        'scroll',
        () => {
          if (!ticking) {
            window.requestAnimationFrame(() => {
              this.handleScroll();
              ticking = false;
            });
            ticking = true;
          }
        },
        { passive: true }
      );

      // Update position on resize
      window.addEventListener('resize', () => {
        this.updateOriginalPosition();
        this.handleScroll();
      });

      // Handle back/forward navigation (bfcache restore)
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
          // Page was restored from bfcache - scroll to top
          this.scrollToTop();
          this.updateOriginalPosition();
          this.handleScroll();
        }
      });
    }

    scrollToTop() {
      // Scroll to top smoothly on mobile devices
      if (window.innerWidth < 768) {
        window.scrollTo({
          top: 0,
          behavior: 'instant',
        });
      }
    }

    updateOriginalPosition() {
      if (!this.stickyBar) return;

      // Temporarily remove sticky class to get true position
      this.stickyBar.classList.remove('is-sticky');
      const rect = this.stickyBar.getBoundingClientRect();
      this.originalPosition = rect.top + window.scrollY;

      // Restore sticky if it was sticky
      if (this.isSticky) {
        this.stickyBar.classList.add('is-sticky');
      }
    }

    handleScroll() {
      if (!this.stickyBar || this.originalPosition === null) return;

      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const barHeight = this.stickyBar.offsetHeight;
      const documentHeight = document.documentElement.scrollHeight;

      // Check if the bar would be below the viewport
      const barBottomPosition = this.originalPosition + barHeight;
      const shouldBeSticky = scrollY + windowHeight > barBottomPosition;

      // Get footer element - try multiple selectors for reliability
      const footer =
        document.querySelector('[id*="shopify-section-footer"]') ||
        document.querySelector('footer') ||
        document.getElementById('footer');

      // Check if footer is visible in viewport
      let shouldHide = false;
      if (footer) {
        const footerRect = footer.getBoundingClientRect();
        // Hide if any part of the footer is visible in the viewport
        shouldHide = footerRect.top < windowHeight;
      } else {
        // Fallback: hide when near bottom of page
        shouldHide = scrollY + windowHeight >= documentHeight - 50;
      }

      // Update sticky state
      if (shouldBeSticky && !this.isSticky) {
        this.stickyBar.classList.add('is-sticky');
        this.isSticky = true;
      } else if (!shouldBeSticky && this.isSticky) {
        this.stickyBar.classList.remove('is-sticky');
        this.isSticky = false;
      }

      // Update hidden state
      if (shouldHide && !this.isHidden) {
        this.stickyBar.classList.add('is-hidden');
        this.isHidden = true;
      } else if (!shouldHide && this.isHidden) {
        this.stickyBar.classList.remove('is-hidden');
        this.isHidden = false;
      }
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new ProductTabs();
      new MobileStickyBar();
    });
  } else {
    new ProductTabs();
    new MobileStickyBar();
  }

  } catch(e) { console.error(e); }
})();
})();
